export default __webpack_public_path__ + "static/0bf2zyjoaaasiaaii5eixzpuftwd4dhbfyaa.f10002-dc3b982277fc39db6e576bdd8e34ab13.mp4";